const state = {
  listaArquivosAssinados: [],
  arquivoAssinadoBlobURL: null,
  arquivoAssinadoInsercaoDialog: false,
  listaTiposAssinatura: []
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/arquivos-assinados/state.js